<template>
  <span>{{ formattedValue }}{{ unit }}</span>
</template>

<script>
export default {
  name: 'FormatNumber',
  props: {
    value: {
      type: [Number, String],
      required: true
    },
    unit: {
      type: String,
      default: ''
    },
    // 是否显示万单位
    showWan: {
      type: Boolean,
      default: true
    },
    // 小数位数
    decimals: {
      type: Number,
      default: 2
    }
  },
  computed: {
    formattedValue() {
      // 转换为数字
      let num = Number(this.value);
      
      // 如果不是有效数字，返回原值
      if (isNaN(num)) {
        return this.value;
      }
      
      // 如果启用万单位且数值大于100000
      if (this.showWan && num >= 100000) {
        num = (num / 100000).toFixed(this.decimals);
        return num;
      }
      
      // 如果是整数，直接返回
      if (Number.isInteger(num)) {
        return num;
      }
      console.log(111,num);
      // 否则保留指定小数位
      return num.toFixed(this.decimals);
    }
  }
}
</script> 